import { observer } from 'mobx-react'
import React, { Component } from 'react'
import styled from 'styled-components'
import Card from '../../components/Card'
import Row from '../../components/Row'
import Select from '../../components/Select'
import Toggle from '../../components/Toggle'
import Text from '../../components/Text'
import patient from '../../stores/patient'

const Question = styled.div`
  font-weight: 500;
  margin-bottom: 1rem;
  line-height: 175%;
  font-size: 1.1rem;
  &::before {
    content: 'Q: ';
  }
`

@observer
export default class Survey extends Component {
  render() {
    return (
      <Card>
        <Card.Pad>
          <Question>
            <Text str="prose.areYouComfortableInternet" />
          </Question>
          <Row>
            <Row.Cell>
              <Toggle radio
                color="red"
                str="titles.yes"
                checked={patient.fields.usesInternet}
                onToggle={() => patient.toggleBooleanField('usesInternet')}
              />
            </Row.Cell>
            <Row.Cell>
              <Toggle radio
                color="red"
                str="titles.no"
                checked={!patient.fields.usesInternet}
                onToggle={() => patient.toggleBooleanField('usesInternet')}
              />
            </Row.Cell>
          </Row>
        </Card.Pad>
        <Card.Divider />
        <Card.Pad>
          <Question>
            <Text str="prose.ifHaveSmartphone" />
          </Question>
          <Row>
            <Row.Cell>
              <Toggle radio
                color="red"
                str="titles.yes"
                checked={patient.fields.usesSmartphone}
                onToggle={() => patient.toggleBooleanField('usesSmartphone')}
              />
            </Row.Cell>
            <Row.Cell>
              <Toggle radio
                color="red"
                str="titles.no"
                checked={!patient.fields.usesSmartphone}
                onToggle={() => patient.toggleBooleanField('usesSmartphone')}
              />
            </Row.Cell>
          </Row>
        </Card.Pad>
        <Card.Divider />
        <Card.Pad>
          <Question>
            <Text str="prose.liveWithAnyone" />
          </Question>
          <Select
            name="socialSupport"
            value={patient.fields.socialSupport}
            onChange={patient.setField}
          >
            <Select.Options choices="socialSupport" />
          </Select>
        </Card.Pad>
      </Card>
    )
  }
}



// WEBPACK FOOTER //
// ./src/pages/Goal/Survey.js